export const productData = {
  name: "MADTOYS Rotating Windmill Night Light",
  tagline: "Where Engineering Meets Art",
  description: "Rotating Copper Wire Windmill Night Light - Desktop Mechanical Art Lamp with Motorized Spinning Blades. Fully Assembled & Ready to Use!",
  price: 1699,
  currency: "INR",
  images: [
    "https://customer-assets-39nsmqrw.emergentagent.net/job_visual-product-hub/artifacts/beot2jig_IMG-20260812-WA0049.jpg",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_visual-product-hub/artifacts/e4kbo2xq_IMG-20260812-WA0050.jpg",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_visual-product-hub/artifacts/2gds727u_IMG-20260812-WA0048.jpg",
    "https://customer-assets-39nsmqrw.emergentagent.net/job_visual-product-hub/artifacts/931tx0yd_IMG-20260812-WA0051.jpg"
  ],
  features: [
    {
      title: "Mesmerizing Illumination",
      description: "LED-lit copper blades create a captivating light show as they rotate",
      icon: "Lightbulb"
    },
    {
      title: "Engineering Marvel",
      description: "Precision-crafted copper wire framework showcases mechanical beauty",
      icon: "Cog"
    },
    {
      title: "Ready to Use",
      description: "Fully assembled and ready to display - perfect gift for your loved ones",
      icon: "Wrench"
    },
    {
      title: "Premium Craftsmanship",
      description: "High-quality materials with attention to every detail",
      icon: "Award"
    },
    {
      title: "Perfect Desk Companion",
      description: "Elegant conversation starter for your workspace or study",
      icon: "Home"
    },
    {
      title: "Educational Tool",
      description: "Learn about renewable energy and mechanical engineering principles",
      icon: "GraduationCap"
    }
  ],
  specifications: {
    "Dimensions": "Tower height: ~25cm",
    "Material": "Copper wire frame, wooden base",
    "Power Source": "2x Rechargeable Lithium-ion batteries (included)",
    "Battery Life": "Up to 1 hour of continuous operation per charge",
    "Charging": "USB charging cable included",
    "Lighting": "LED illuminated blades",
    "Motor": "Low voltage DC motor",
    "Assembly": "Fully assembled - No assembly required!"
  },
  useCases: [
    {
      title: "For Tech Enthusiasts",
      description: "A stunning display of mechanical artistry that celebrates innovation and precision engineering",
      audience: "engineers"
    },
    {
      title: "Perfect Gift Choice",
      description: "Fully assembled and beautifully packaged - ready to gift for birthdays, anniversaries, or any special occasion",
      audience: "gifters"
    },
    {
      title: "Educational Purpose",
      description: "Visual demonstration tool for students exploring physics, engineering, and renewable energy concepts",
      audience: "educators"
    }
  ],
  faqs: [
    {
      question: "Does it require assembly?",
      answer: "No! The MADTOYS Windmill Night Light comes fully assembled and ready to use right out of the box. Just charge the batteries and turn it on - perfect for gifting!"
    },
    {
      question: "How does it get power?",
      answer: "It comes with 2 rechargeable lithium-ion batteries that power the motor and LED lights. The batteries provide up to 1 hour of continuous operation and can be easily recharged using the included USB charging cable."
    },
    {
      question: "How long does the battery last?",
      answer: "On a full charge, the batteries provide at least 1 hour of continuous spinning and illumination. Charging time is approximately 2-3 hours via the included USB cable."
    },
    {
      question: "What's included in the box?",
      answer: "You'll receive the fully assembled windmill lamp, 2 rechargeable lithium-ion batteries (pre-installed), USB charging cable, and user manual. Everything you need to start enjoying your mechanical masterpiece!"
    },
    {
      question: "Is it a good gift option?",
      answer: "Absolutely! It comes beautifully packaged and fully assembled - no setup required. It's a unique, impressive gift perfect for tech lovers, engineers, students, or anyone who appreciates innovative design."
    },
    {
      question: "What makes it educational?",
      answer: "It's a working demonstration of renewable energy principles, rotational mechanics, and LED technology. Students can observe real-time mechanical and electrical concepts in action without needing to assemble anything."
    }
  ]
};
